// 公共地区列表（含国旗 emoji 和中文名称）
export const STOREFRONTS = [
  { code: 'cn', name: '中国', flag: '🇨🇳' },
  { code: 'us', name: '美国', flag: '🇺🇸' },
  { code: 'jp', name: '日本', flag: '🇯🇵' },
  { code: 'hk', name: '中国香港', flag: '🇭🇰' },
  { code: 'tw', name: '中国台湾', flag: '' },
  { code: 'mo', name: '中国澳门', flag: '🇲🇴' },
  { code: 'kr', name: '韩国', flag: '🇰🇷' },
  { code: 'sg', name: '新加坡', flag: '🇸🇬' },
  { code: 'gb', name: '英国', flag: '🇬🇧' },
  { code: 'de', name: '德国', flag: '🇩🇪' },
  { code: 'fr', name: '法国', flag: '🇫🇷' },
  { code: 'ca', name: '加拿大', flag: '🇨🇦' },
  { code: 'au', name: '澳大利亚', flag: '🇦🇺' },
  { code: 'sa', name: '沙特', flag: '🇸🇦' },
  { code: 'ae', name: '阿联酋', flag: '🇦🇪' },
  { code: 'in', name: '印度', flag: '🇮🇳' },
  { code: 'id', name: '印尼', flag: '🇮🇩' },
  { code: 'th', name: '泰国', flag: '🇹🇭' },
  { code: 'vn', name: '越南', flag: '🇻🇳' },
  { code: 'br', name: '巴西', flag: '🇧🇷' },
  { code: 'mx', name: '墨西哥', flag: '🇲🇽' },
];
